/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Code from './icon-code.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Code {...validProps} />;
}
SvgComponent.iconName = 'code';

export const CodeIcon = svgIconWrapper(SvgComponent);
